import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRuler12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconRuler12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 1.5V6h2V5h-.5a.5.5 0 0 1 0-1H5V3h-.5a.5.5 0 0 1 0-1H5v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5m3 3v-3A1.5 1.5 0 0 0 4.5 0h-1A1.5 1.5 0 0 0 2 1.5V6h-.5A1.5 1.5 0 0 0 0 7.5v1A1.5 1.5 0 0 0 1.5 10H2v.5A1.5 1.5 0 0 0 3.5 12h1A1.5 1.5 0 0 0 6 10.5V10h3.5A1.5 1.5 0 0 0 11 8.5v-1A1.5 1.5 0 0 0 9.5 6H6zm-2 3V7H3v.5a.5.5 0 0 1-1 0V7h-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H9v.5a.5.5 0 0 1-1 0V7H7v.5a.5.5 0 0 1-1 0V7H5v.5a.5.5 0 0 1-1 0M3 10v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V10z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRuler12);
